<template>
  <div>
    <div class="flex w-full items-center">
      <div class="pr-8 w-1/3">
        <input class="w-full py-1 px-3 border-2 rounded bg-white outline-none focus:border-primary-500 appearance-none" :class="{ 'border-red-600': this.errorBag.get('email') }" type="text"
               placeholder="Email address" v-model="member.email" @blur="updateMemberStatus">
        <small class="text-sm text-red mb-3" v-text="this.errorBag.get('email')"></small>
      </div>
      <div class="flex w-2/3 items-center pl-16">
        <checkbox-input v-model="member.members_hub_profile" :value="true" @input="updateMemberStatus" />
        <checkbox-input v-model="member.receiving_marketing_emails" :value="true" @input="updateMemberStatus" />
        <checkbox-input v-model="member.facebook_group_user" :value="true" @input="updateMemberStatus" />
        <checkbox-input v-model="member.passed_associate_scheme" :value="true" @input="updateMemberStatus" />
        <checkbox-input v-model="member.active_referrals" :value="true" @input="updateMemberStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import ErrorBag from '@/ErrorBag'
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: Object
    }
  },
  data: function () {
    return {
      member: this.value,
      errorBag: new ErrorBag()
    }
  },
  computed: {
    ...mapState(['annualReview'])
  },
  methods: {
    updateMemberStatus: function () {
      this.errorBag.clear()
      v2Api.post(`/annual-reviews/${this.annualReview.id}/update-member-status`,
        { 'email': this.member.email,
          'members_hub_profile': this.member.members_hub_profile,
          'receiving_marketing_emails': this.member.receiving_marketing_emails,
          'facebook_group_user': this.member.facebook_group_user,
          'passed_associate_scheme': this.member.passed_associate_scheme,
          'active_referrals': this.member.active_referrals }).then(
        response => {
        },
        errors => {
          this.errorBag.store(errors.response.data)
        }
      )
    }
  }
}
</script>
